// extracted by mini-css-extract-plugin
export default {"bookingCard":"BookingCard_bookingCard__ryzwD","bookingInfo":"BookingCard_bookingInfo__2Au0r","viewButton":"BookingCard_viewButton__HsIwe"};